"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = require("redux");

var _actionTypes = require("../actions/actionTypes");

var actionTypes = _interopRequireWildcard(_actionTypes);

var _creator = require("./creator");

var _collections = require("./collections");

var _denial = require("./denial");

var _icons = require("./icons");

var _paginate = require("./paginate");

var _paginate2 = _interopRequireDefault(_paginate);

var _plugin = require("./plugin");

var _search = require("./search");

var _upload = require("./upload");

var _newUploadKeys = require("./new-upload-keys");

var _newUploadSearchKeys = require("./new-upload-search-keys");

var _saveForLaterKeys = require("./save-for-later-keys");

var _saveForLaterSearchKeys = require("./save-for-later-search-keys");

var _suspendedKeys = require("./suspended-keys");

var _suspendedSearchKeys = require("./suspended-search-keys");

var _user = require("./user");

var _apiResponse = require("./apiResponse");

var _apiResponse2 = _interopRequireDefault(_apiResponse);

var _payments = require("./payments");

var _payments2 = _interopRequireDefault(_payments);

var _modal = require("./modal");

var _modal2 = _interopRequireDefault(_modal);

var _download = require("./download");

var _download2 = _interopRequireDefault(_download);

var _stripe = require("./stripe");

var _stripe2 = _interopRequireDefault(_stripe);

var _reduxWindowsize = require("redux-windowsize");

var _reduxWindowsize2 = _interopRequireDefault(_reduxWindowsize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
 * Redux reducers live here. Read Redux docs for more information:
 * http://redux.js.org/docs/basics/Reducers.html
 */

if (!global._babelPolyfill) {
    require("babel-polyfill");
}

// Updates the pagination data for different actions.
var pagination = (0, _redux.combineReducers)({
    featuredCreators: (0, _paginate2.default)({
        mapActionToKey: function mapActionToKey(action) {
            return action.id;
        },
        types: [actionTypes.FETCH_FEATURED_CREATORS, actionTypes.FETCH_FEATURED_CREATORS_SUCCESS, actionTypes.FETCH_FEATURED_CREATORS_FAILURE]
    }),
    newUploads: (0, _paginate2.default)({
        mapActionToKey: function mapActionToKey(action) {
            return action.id;
        },
        types: [actionTypes.FETCH_NEW_UPLOADS, actionTypes.FETCH_NEW_UPLOADS_SUCCESS, actionTypes.FETCH_NEW_UPLOADS_FAILURE]
    }),
    savedUploads: (0, _paginate2.default)({
        mapActionToKey: function mapActionToKey(action) {
            return action.id;
        },
        types: [actionTypes.FETCH_SAVED_UPLOADS, actionTypes.FETCH_SAVED_UPLOADS_SUCCESS, actionTypes.FETCH_SAVED_UPLOADS_FAILURE]
    }),
    suspendedUploads: (0, _paginate2.default)({
        mapActionToKey: function mapActionToKey(action) {
            return action.id;
        },
        types: [actionTypes.FETCH_SUSPENDED_UPLOADS, actionTypes.FETCH_SUSPENDED_UPLOADS_SUCCESS, actionTypes.FETCH_SUSPENDED_UPLOADS_FAILURE]
    }),
    uploadIcons: (0, _paginate2.default)({
        mapActionToKey: function mapActionToKey(action) {
            return action.id;
        },
        types: [actionTypes.FETCH_UPLOAD_ICONS, actionTypes.FETCH_UPLOAD_ICONS_SUCCESS, actionTypes.FETCH_UPLOAD_ICONS_FAILURE]
    }),
    previewIcons: (0, _paginate2.default)({
        mapActionToKey: function mapActionToKey(action) {
            return action.id;
        },
        types: [actionTypes.PREVIEW_UPLOAD_ICONS, actionTypes.PREVIEW_UPLOAD_ICONS_SUCCESS, actionTypes.PREVIEW_UPLOAD_ICONS_FAILURE]
    }),
    fetchBestCollectionIcons: (0, _paginate2.default)({
        mapActionToKey: function mapActionToKey(action) {
            return action.id;
        },
        types: [actionTypes.FETCH_BEST_COLLECTIONS, actionTypes.FETCH_BEST_COLLECTIONS_SUCCESS, actionTypes.FETCH_BEST_COLLECTIONS_FAILURE]
    }),
    fetchViewMoreIcons: (0, _paginate2.default)({
        mapActionToKey: function mapActionToKey(action) {
            return action.id;
        },
        types: [actionTypes.FETCH_VIEW_MORE_ICONS, actionTypes.FETCH_VIEW_MORE_ICONS_SUCCESS, actionTypes.FETCH_VIEW_MORE_ICONS_FAILURE]
    }),
    searchIcons: (0, _paginate2.default)({
        mapActionToKey: function mapActionToKey(action) {
            return action.id;
        },
        types: [actionTypes.SEARCH_ICONS, actionTypes.SEARCH_ICONS_SUCCESS, actionTypes.SEARCH_ICONS_FAILURE]
    }),
    searchTerm: (0, _paginate2.default)({
        mapActionToKey: function mapActionToKey(action) {
            return action.id;
        },
        types: [actionTypes.SEARCH_ICONS, actionTypes.SEARCH_ICONS_SUCCESS, actionTypes.SEARCH_ICONS_FAILURE]
    }),
    fetchRecentIcons: (0, _paginate2.default)({
        mapActionToKey: function mapActionToKey(action) {
            return action.id;
        },
        types: [actionTypes.SEARCH_ICONS, actionTypes.SEARCH_ICONS_SUCCESS, actionTypes.SEARCH_ICONS_FAILURE]
    }),
    searchCreatorIcons: (0, _paginate2.default)({
        mapActionToKey: function mapActionToKey(action) {
            return action.id;
        },
        types: [actionTypes.SEARCH_ICONS, actionTypes.SEARCH_ICONS_SUCCESS, actionTypes.SEARCH_ICONS_FAILURE]
    }),
    searchCollectionIcons: (0, _paginate2.default)({
        mapActionToKey: function mapActionToKey(action) {
            return action.id;
        },
        types: [actionTypes.SEARCH_ICONS, actionTypes.SEARCH_ICONS_SUCCESS, actionTypes.SEARCH_ICONS_FAILURE]
    }),
    searchCreatorUploads: (0, _paginate2.default)({
        mapActionToKey: function mapActionToKey(action) {
            return action.id;
        },
        types: [actionTypes.SEARCH_ICONS, actionTypes.SEARCH_ICONS_SUCCESS, actionTypes.SEARCH_ICONS_FAILURE]
    }),
    fetchCollection: (0, _paginate2.default)({
        mapActionToKey: function mapActionToKey(action) {
            return action.id;
        },
        types: [actionTypes.SEARCH_ICONS, actionTypes.SEARCH_ICONS_SUCCESS, actionTypes.SEARCH_ICONS_FAILURE]
    })
});

var rootReducer = (0, _redux.combineReducers)(_defineProperty({
    creator: _creator.creator,
    collections: _collections.collections,
    denial: _denial.denial,
    icons: _icons.icons,
    pagination: pagination,
    plugin: _plugin.plugin,
    search: _search.search,
    uploads: _upload.uploads,
    uploadsNewKeys: _newUploadKeys.uploadsNewKeys,
    uploadsNewSearchKeys: _newUploadSearchKeys.uploadsNewSearchKeys,
    uploadsSaveForLaterKeys: _saveForLaterKeys.uploadsSaveForLaterKeys,
    uploadsSaveForLaterSearchKeys: _saveForLaterSearchKeys.uploadsSaveForLaterSearchKeys,
    uploadsSuspendedKeys: _suspendedKeys.uploadsSuspendedKeys,
    uploadsSuspendedSearchKeys: _suspendedSearchKeys.uploadsSuspendedSearchKeys,
    user: _user.user,
    apiResponse: _apiResponse2.default,
    payments: _payments2.default,
    modal: _modal2.default,
    download: _download2.default,
    stripe: _stripe2.default
}, _reduxWindowsize.REDUCER_KEY, _reduxWindowsize2.default));

exports.default = rootReducer;